mutation SetAircallIntegrationIsEnabledForUser($isEnabled: Boolean!) {
    setAircallIntegrationIsEnabledForUser(input: {isEnabled: $isEnabled}) {
        integration {
            isEnabledForUser
            integrationType
            externalUserIdentifier
            tertiaryInformation
        }
    }
}
